import dompurify from 'dompurify';

export const useSanitiseHtml = (html?: string) => {
  return dompurify.sanitize(html ?? '', {
    ADD_ATTR: ['target'],
  });
};
